import { i18n, useI18n } from 'i18n-utils'
import { InvestFinancialService } from 'network'
import { PageRoutes } from 'platform-config/src/router/PageRoutes'
import { useChangeLanguage } from '../hooks/use-change-language'

export enum InvestFinancialTab {
  /** 活期 */
  Period = 'period',
  /** 定期 */
  Fixed = 'fixed',
  /** 量化理财 */
  QuantitativeFinance = 'quantitative-finance',
  /** 链上赚币 */
  ChainEarn = 'chain-earn',
}

export const InvestFinancialTabTypes: Record<InvestFinancialTab, number> = {
  [InvestFinancialTab.Fixed]: 1,
  [InvestFinancialTab.Period]: 2,
  [InvestFinancialTab.QuantitativeFinance]: 3,
  [InvestFinancialTab.ChainEarn]: 4,
}

type TabItem = {
  name: InvestFinancialTab
  label: string
}

export const isPeriod = (product: InvestFinancialResponse.InvestFinancialProductItem | InvestFinancialResponse.SubProductItem) => {
  const showLockPeriod = product.showLockPeriod
  return showLockPeriod && showLockPeriod !== '0'
}

export const lockedPeriodText = (product: InvestFinancialResponse.InvestFinancialProductItem | InvestFinancialResponse.SubProductItem) => {
  const productType = product.productType
  if ([1, 2].includes(productType)) {
    return isPeriod(product)
      ? i18n.global.t('{days}天', {
          days: product.showLockPeriod ?? '',
        })
      : i18n.global.t('无限期')
  } else if ([3, 4].includes(productType)) {
    return isPeriod(product)
      ? i18n.global.t('{days}天', {
          days: product.showLockPeriod ?? '',
        })
      : ''
  } else {
    return ''
  }
}

export const useInvestFinancialStore = defineStore('investFinancialStore', () => {
  const recommendProducts = ref<InvestFinancialResponse.InvestFinancialProductItem[]>([])
  const loading = ref(false)
  const { t } = useI18n()
  const loadingProducts = ref(false)
  const router = useRouter()
  const productMap = ref<Record<InvestFinancialTab, InvestFinancialResponse.InvestFinancialProductItem[]>>({
    [InvestFinancialTab.Period]: [],
    [InvestFinancialTab.Fixed]: [],
    [InvestFinancialTab.QuantitativeFinance]: [],
    [InvestFinancialTab.ChainEarn]: [],
  })

  const tabs: TabItem[] = [
    {
      name: InvestFinancialTab.Period,
      label: '活期',
    },
    {
      name: InvestFinancialTab.Fixed,
      label: '定期',
    },

    // {
    //   name: InvestFinancialTab.QuantitativeFinance,
    //   label: '量化理财',
    // },
    // {
    //   name: InvestFinancialTab.ChainEarn,
    //   label: '链上赚币',
    // },
  ]

  const activeTab = ref(InvestFinancialTab.Period)

  const getRecommendProducts = async () => {
    loading.value = true
    const res = await InvestFinancialService.getRecommendProducts()
    loading.value = false
    // 暂时只上定期和活期
    recommendProducts.value = res.data.filter((item) => [1, 2].includes(item.productType))
  }

  useChangeLanguage(getRecommendProducts)

  const getTagText = (type: string) => {
    switch (type) {
      case '1':
        return '稳定型'
      case '2':
        return '进取型'
      case '3':
        return '谨慎型'
      case '4':
        return '活期'
      case '5':
        return '定期'
      default:
        return '--'
    }
  }

  const getProducts = async (tab: InvestFinancialTab) => {
    if (loadingProducts.value) return
    loadingProducts.value = true
    const res = await InvestFinancialService.getProducts({
      productType: InvestFinancialTabTypes[tab],
    })
    loadingProducts.value = false
    productMap.value[tab] = res.data
  }

  const products = computed(() => {
    return productMap.value[activeTab.value]
  })

  useChangeLanguage(async () => {
    const tab = tabs.find((tab) => tab.name === activeTab.value)
    if (tab) {
      getProducts(tab.name)
    }
  })

  /** 获取稳定性文字 */
  const getStabilityText = (product: InvestFinancialResponse.InvestFinancialProductItem) => {
    if (product.riskType === 1) {
      return t('稳定型')
    } else if (product.riskType === 2) {
      return t('风险型')
    }
    return ''
  }

  const isQuantAndChain = (product: InvestFinancialResponse.InvestFinancialProductItem) => {
    return [3, 4].includes(product.productType)
  }

  const goToProductDetail = (product: InvestFinancialResponse.InvestFinancialProductItem, sub?: InvestFinancialResponse.SubProductItem) => {
    const isPeriod = product.productType === InvestFinancialTabTypes[InvestFinancialTab.Period]
    const subProduct = isPeriod ? undefined : sub || product.subProductList[0]
    console.log('sub', sub?.subProductId)
    router.push({
      path: PageRoutes.InvestProductDetail,
      query: {
        productId: product.productId,
        isSpecial: product.isSpecial,
        itemId: product.itemId,
        productType: product.productType,
        ...(subProduct ? { subProductId: subProduct.subProductId } : {}),
      },
    })
  }

  return {
    getRecommendProducts,
    recommendProducts,
    loading,
    getTagText,
    lockedPeriodText,
    tabs,
    activeTab,
    getProducts,
    loadingProducts,
    products,
    getStabilityText,
    isQuantAndChain,
    goToProductDetail,
  }
})
